import styled from "styled-components";

const SectionHeaderEndContainer = styled.div`
	margin-left: 8px;
`;

export default SectionHeaderEndContainer;
